/*! js-cookie v3.0.5 | MIT */
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e = "undefined" != typeof globalThis ? globalThis : e || self),
      (function () {
        var n = e.Cookies,
          o = (e.Cookies = t());
        o.noConflict = function () {
          return (e.Cookies = n), o;
        };
      })());
})(this, function () {
  "use strict";
  function e(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) e[o] = n[o];
    }
    return e;
  }
  var t = (function t(n, o) {
    function r(t, r, i) {
      if ("undefined" != typeof document) {
        "number" == typeof (i = e({}, o, i)).expires &&
          (i.expires = new Date(Date.now() + 864e5 * i.expires)),
          i.expires && (i.expires = i.expires.toUTCString()),
          (t = encodeURIComponent(t)
            .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
            .replace(/[()]/g, escape));
        var c = "";
        for (var u in i)
          i[u] &&
            ((c += "; " + u), !0 !== i[u] && (c += "=" + i[u].split(";")[0]));
        return (document.cookie = t + "=" + n.write(r, t) + c);
      }
    }
    return Object.create(
      {
        set: r,
        get: function (e) {
          if ("undefined" != typeof document && (!arguments.length || e)) {
            for (
              var t = document.cookie ? document.cookie.split("; ") : [],
                o = {},
                r = 0;
              r < t.length;
              r++
            ) {
              var i = t[r].split("="),
                c = i.slice(1).join("=");
              try {
                var u = decodeURIComponent(i[0]);
                if (((o[u] = n.read(c, u)), e === u)) break;
              } catch (e) {}
            }
            return e ? o[e] : o;
          }
        },
        remove: function (t, n) {
          r(t, "", e({}, n, { expires: -1 }));
        },
        withAttributes: function (n) {
          return t(this.converter, e({}, this.attributes, n));
        },
        withConverter: function (n) {
          return t(e({}, this.converter, n), this.attributes);
        },
      },
      {
        attributes: { value: Object.freeze(o) },
        converter: { value: Object.freeze(n) },
      }
    );
  })(
    {
      read: function (e) {
        return (
          '"' === e[0] && (e = e.slice(1, -1)),
          e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
        );
      },
      write: function (e) {
        return encodeURIComponent(e).replace(
          /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
          decodeURIComponent
        );
      },
    },
    { path: "/" }
  );
  return t;
});

(function () {
  // auth.js
  const APP_ENV = window.renogyConfig.mode;
  const ACCESS_TOKEN_KEY = `renogy_account_access_token_key_${APP_ENV}_1.0`;
  const REFRESH_TOKEN_KEY = `renogy_account_refresh_token_key_${APP_ENV}_1.0`;
  const API_DOMAIN = window.renogyConfig.apiUrl;

  let isRefreshing = false;
  let refreshPromise = null;
  let pendingRequests = [];

  function getAccessToken() {
    return Cookies.get(ACCESS_TOKEN_KEY);
  }

  function getRefreshToken() {
    return Cookies.get(REFRESH_TOKEN_KEY);
  }

  // 刷新 token：只刷新一次，并排队等待
  function refreshToken() {
    if (isRefreshing) {
      return refreshPromise;
    }

    // 没有 refreshToken 时不调用刷新接口：保持 Promise 契约并让外层按原链路处理
    const rt = getRefreshToken();
    if (!rt) {
      // 清空挂起请求，避免队列泄漏/卡住
      pendingRequests = [];
      return Promise.reject(new Error("Refresh token not found"));
    }

    isRefreshing = true;

    refreshPromise = new Promise(function (resolve, reject) {
      fetch(API_DOMAIN + "/api/v1/account/pc/do_refresh", {
        method: "POST",
        headers: {
          "X-Token": `${getAccessToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refreshToken: `${rt}`,
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Refresh failed");
          return response.json();
        })
        .then(function (resp) {
          Cookies.set(ACCESS_TOKEN_KEY, resp.data.accessToken, {
            domain: ".renogy.com",
            expires: 370,
            sameSite: "strict",
          });
          Cookies.set(REFRESH_TOKEN_KEY, resp.data.refreshToken, {
            domain: ".renogy.com",
            expires: 370,
            sameSite: "strict",
          });

          resolve(resp);

          // 执行所有挂起请求
          for (var i = 0; i < pendingRequests.length; i++) {
            pendingRequests[i]();
          }
          pendingRequests = [];
        })
        .catch(function (err) {
          // logout _shopify_essential
          pendingRequests = [];
          const link = document.createElement("a");
          link.href = window.theme.routes.logout;
          document.body.appendChild(link);
          link.click();
          reject(err);
        })
        .finally(function () {
          isRefreshing = false;
          refreshPromise = null;
        });
    });

    return refreshPromise;
  }

  function request(url, options, isRetry, isUrl) {
    options = options || {};
    options.headers = options.headers || {};
    options.headers["Content-Type"] = "application/json";
    options.headers["X-Token"] = getAccessToken();

    return fetch(!isUrl ? API_DOMAIN + url : url, options).then(function (
      response
    ) {
      if (response.status === 401 && !isRetry) {
        // Token 过期，排队等待刷新完成
        return new Promise(function (resolve, reject) {
          pendingRequests.push(function () {
            request(url, options, true).then(resolve).catch(reject);
          });

          refreshToken().catch(reject); // 刷新失败则中断所有请求
        });
      }

      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error("HTTP Error " + response.status + ": " + text);
        });
      }

      return response.json();
    });
  }

  function pagination() {
    // data-filter-update-url
    return {
      currentPage: 1,
      totalPages: 0,
      ready: false,
      url: "",
      pages: [],
      filterUpdateUrlButton: "[data-filter-url]",
      getPagination(currentPage, totalPages) {
        const maxVisiblePages = 5; // 中间最多显示的数字数
        const pages = [];

        if (totalPages <= 1) {
          return pages;
        }

        // 添加第一页
        pages.push(1);

        if (currentPage > Math.ceil(maxVisiblePages / 2) + 1) {
          pages.push("...");
        }

        const startPage = Math.max(
          2,
          currentPage - Math.floor(maxVisiblePages / 2)
        );
        const endPage = Math.min(
          totalPages - 1,
          currentPage + Math.floor(maxVisiblePages / 2)
        );

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (endPage < totalPages - 1) {
          pages.push("...");
        }

        // 添加最后一页
        if (totalPages > 1) {
          pages.push(totalPages);
        }

        return pages;
      },
      updateFilterFromUrl(e) {
        const target = e.target;
        if (
          target.matches(this.filterUpdateUrlButton) ||
          (target.closest(this.filterUpdateUrlButton) && target)
        ) {
          e.preventDefault();

          const button = target.matches(this.filterUpdateUrlButton)
            ? target
            : target.closest(this.filterUpdateUrlButton);
          this.filtering(e, button.getAttribute("href"));
        }
      },
      filtering(e, replaceHref = "") {
        if (e.state === null) return; // skip when we update the url with a button with href="#id" used for link
        // Scroll to filter tools
        let options = {
          root: null,
          rootMargin: `${0}px`,
          threshold: 1.0,
        };
        const container = document.querySelector("body");
        const handleFilterAndScroll = (entries) => {
          const [entry] = entries;
          setTimeout(() => {
            this.addToHistory(e, replaceHref);
            this.getFilterResult();
          }, 0);
          observer.unobserve(container);
          if (entry.isIntersecting) return;
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        };
        const observer = new IntersectionObserver(
          handleFilterAndScroll,
          options
        );
        observer.observe(container);
      },
      addToHistory(e, replaceHref) {
        if (!e || (e && e.type !== "popstate")) {
          if (replaceHref === "") {
            const searchParams = new window.URL(window.location.href)
              .searchParams;
            const filterUrlParams = Object.fromEntries(searchParams);
            const filterUrlRemoveString = searchParams.toString();
            if (filterUrlRemoveString.includes("page")) {
              for (const key in filterUrlParams) {
                if (key.includes("page")) {
                  searchParams.delete(key);
                }
              }
            }

            const filterUrlString = searchParams.toString();
            const filterNewParams = filterUrlString
              ? `?${filterUrlString}`
              : location.pathname;
            window.history.pushState(null, "", filterNewParams);
            return;
          }
          window.history.pushState(null, "", replaceHref);
        }
      },
      getFilterResult() {
        const link = new URL(window.location.href);
        let page = link.searchParams.get("page");
        this.currentPage = page ? page : 1;
        this.ready = false;
        document.dispatchEvent(
          new CustomEvent("change:pagination:data", {
            detail: {
              page: this.currentPage,
              loading: true,
            },
            bubbles: true,
          })
        );
      },
      init() {
        const self = this;
        this.url = window.location.href.split("?")[0];

        document
          .querySelector(".my-pagination")
          .addEventListener("click", (e) => {
            this.updateFilterFromUrl(e);
          });

        document.addEventListener("init:pagination", function (event) {
          self.totalPages = event.detail.totalPages;
          if (self.totalPages <= 1) {
            self.ready = false;
            self.pages = [];
            return;
          }
          const link = new URL(window.location.href);
          const page = link.searchParams.get("page");
          self.ready = true;
          if (page) {
            self.currentPage = parseInt(page, "10");
          }
          self.pages = self.getPagination(self.currentPage, self.totalPages);
        });
      },
    };
  }

  function accountHomePage() {
    return {
      storeId: window.renogyConfig.storeId,
      level: "",
      progress: "",
      email: "",
      birth: "",
      rays: "",
      next_level_earn: "",
      couponNumber: 0,
      userBonusPoints: 0,
      pendingRays:0,
      giftCardNumber:0,
      taskList: [],
      tooltipInitialized: false,
      globalClickHandlerBound: false,
      globalClickHandler: null,
      tooltipEventHandlers: {},
      apiUrl:'',
      storeName:'',
      getProgress: function (currentLevel, currentRays) {
        const levelMinRays = {
          1: 0,
          2: 400,
          3: 5000,
          4: 30000,
        };
        let width = 100;
        if (currentLevel < 4) {
          let currentMinRays = levelMinRays[currentLevel];
          let nextMinRays = levelMinRays[currentLevel + 1];
          width =
            (0.33 * (currentLevel - 1) +
              (0.33 * (currentRays - currentMinRays)) /
                (nextMinRays - currentMinRays)) *
            100;
        }
        return width;
      },
      getPointsTask: function () {
        // 分页查询积分任务列表

        request(
          "/mem-service/api/v1/bigcommerce/page_bonus_points_task?storeId=" +
            this.storeId +
            "&pageSize=100",
          {}
        ).then((resp) => {
          if (resp.code === "000000") {
            this.taskList = resp.data.contentList;
          }
        });
      },
      getUser: function () {
        request("/api/v1/account/security/get_security_info", {})
          .then((resp) => {
            if (resp.code === "000000") {
              console.log(resp.data);
              this.email = resp.data.email.email;
              this.apiUrl = this.getSite().apiUrl;
              this.storeName = this.getSite().site;
              this.getGiftCards();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },
      getInfo: function () {
        request(
          "/mem-service/api/v1/bigcommerce/get_user_information?storeId=" +
            this.storeId,
          {}
        ).then((resp) => {
          if (resp.code === "000000") {
            const info = resp.data;
            this.couponNumber = resp.data.couponNumber;
            this.userBonusPoints = resp.data.userBonusPoints;
            this.pendingRays = resp.data.userFrozenBonusPoints || 0;
            // this.giftCardNumber = resp.data.giftCardNumber || 0;

            const data = info || {
              userLevelInfo: "EG1",
              userBonusPoints: 0,
              couponNumber: 0,
            };
            const levelObj = {
              EG1: 1,
              EG2: 2,
              EG3: 3,
              EG4: 4,
            };
            const EGMessageg = {
              EG1: {
                new: "6% off for the first order <br> (Renogy DC HOME App users only)",
                earn: "$1=10R",
                birth: "Birthday Rays 50R",
                free: "10%~25% restocking fee",
                next_level_earn: "$1 spent equals 10 Rays earned",
              },
              EG2: {
                new: "",
                earn: "$1=10R",
                birth: "Birthday Rays 50R $5 off coupon * 1",
                free: "10%~25% restocking fee",
                next_level_earn: "$1 spent equals 12 Rays earned",
              },
              EG3: {
                new: "",
                earn: "$1=12R",
                birth: "Birthday Rays 50R $5 off coupon * 1 5% off coupon * 1",
                free: "10%~25% restocking fee",
                next_level_earn: "$1 spent equals 15 Rays earned",
              },
              EG4: {
                new: "",
                earn: "$1=15R",
                birth: "Birthday Rays 50R $5 off coupon * 1 5% off coupon * 1",
                free: "Free return for all orders",
                next_level_earn: "$1 spent equals 15 Rays earned",
              },
            };
            let level = levelObj[data.userLevelInfo];
            this.level = "L" + level;
            let progress = this.getProgress(level, data.userBonusPoints) + "%";
            this.progress = progress;
            const message = EGMessageg[data.userLevelInfo];
            this.birth = message.birth;
            this.rays = message.earn;
            this.next_level_earn = message.next_level_earn;
          } else if (resp.code === "SEC003") {
            // token 过期
          }
        });
      },
      getSite(){
            const currentDomain = window.location.hostname;
            switch (currentDomain) {
            case "uk.renogy.com":
                return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
            case "www.renogy.com":
                return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
            case "ca.renogy.com":
                return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
             case "eu.renogy.com":
                return {site:"EU",apiUrl:`https://shopify-api.renogy.com`};
            case "au.renogy.com":
                return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
            case "de.renogy.com":
                return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
            case "jp.renogy.com":
                return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
            case "fr.renogy.com":
                return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
            case "nl.renogy.com":
                return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
            case "it.renogy.com":
                return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
            case "es.renogy.com":
                return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
            default:
                return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
            }
      },
      /**
       * 检测是否为触摸设备
       */
      _isTouchDevice: function() {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || window.innerWidth <= 768;
      },
      
      /**
       * 移动端：动态设置提示框位置和小三角
       */
      _positionMobileTooltip: function(icon, tooltip) {
        const self = this;
        
        // 先确保 opacity 为 0，避免位置变化时看到移动过程
        tooltip.style.setProperty('opacity', '0', 'important');
        tooltip.style.setProperty('visibility', 'visible', 'important');
        
        // 等待一帧确保 DOM 已渲染并获取正确高度
        requestAnimationFrame(function() {
          // 清除之前的位置样式
          tooltip.style.removeProperty('top');
          tooltip.style.removeProperty('transform');
          tooltip.style.removeProperty('--arrow-offset');
          
          // 再等一帧获取渲染后的高度
          requestAnimationFrame(function() {
            const iconRect = icon.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            
            // 获取提示框实际高度
            let tooltipHeight = tooltipRect.height;
            
            // 如果获取不到高度，使用 offsetHeight 或默认值
            if (!tooltipHeight || tooltipHeight < 50) {
              tooltipHeight = tooltip.offsetHeight || tooltip.scrollHeight || 150;
            }
            
            
            // 计算小三角的位置（指向图标的水平中心）
            const iconCenterX = iconRect.left + iconRect.width / 2;
            const screenCenterX = window.innerWidth / 2;
            const arrowOffset = iconCenterX - screenCenterX;
            
            // 先设置位置（opacity 仍为 0，用户看不见）
            tooltip.style.setProperty('top', '0px', 'important');
            tooltip.style.setProperty('transform', 'translateX(-50%) translateY(-56px) scale(1)', 'important');
            tooltip.style.setProperty('--arrow-offset', arrowOffset + 'px');
            
            
            // 等待下一帧，确保位置已渲染，然后再显示（淡入效果）
            requestAnimationFrame(function() {
              tooltip.style.setProperty('opacity', '1', 'important');
            });
          });
        });
      },
      
      /**
       * 关闭单个 tooltip（带淡出效果）
       */
      _closeSingleTooltip: function(icon) {
        const self = this;
        const tooltip = icon.querySelector('.rg-info-tips');
        
        // 移动端：先淡出，保持位置不变
        if (tooltip && window.innerWidth <= 768) {
          // 先设置 opacity 为 0（开始淡出动画）
          tooltip.style.setProperty('opacity', '0', 'important');
          
          // 等待过渡动画完成（0.2s）后再清理
          setTimeout(function() {
            // 移除 active class
            icon.classList.remove('active');
            
            // 清除所有动态样式
            tooltip.style.removeProperty('opacity');
            tooltip.style.removeProperty('visibility');
            tooltip.style.removeProperty('top');
            tooltip.style.removeProperty('transform');
            tooltip.style.removeProperty('--arrow-offset');
          }, 200); // 与 CSS transition 时长一致
        } else {
          // 桌面端：直接移除 active class（由 CSS 控制过渡）
          icon.classList.remove('active');
        }
      },
      
      /**
       * 关闭指定容器内的所有 tooltip
       */
      _closeAllTooltips: function(container) {
        const self = this;
        const tooltipIcons = container.querySelectorAll('.rg-info-tips-icon.active');
        
        tooltipIcons.forEach(function(icon) {
          self._closeSingleTooltip(icon);
        });
        
        // 恢复页面滚动（移动端）
        if (self._isTouchDevice()) {
          document.body.style.overflow = '';
        }
        
      },
      
      /**
       * 初始化移动端 Tooltip（使用事件委托）
       */
      _initMobileTooltips: function(container, tooltipIcons) {
        const self = this;
        
        // 点击事件处理函数
        self.tooltipEventHandlers.click = function(e) {
          const icon = e.target.closest('.rg-info-tips-icon');
          const tooltip = e.target.closest('.rg-info-tips');
          
          // 1. 点击图标
          if (icon) {
            e.preventDefault();
            e.stopPropagation();
            
            const isActive = icon.classList.contains('active');
            
            // 先关闭所有 tooltip
            self._closeAllTooltips(container);
            
            // 如果原本不是激活状态，则激活当前 tooltip
            if (!isActive) {
              icon.classList.add('active');
              
              // 移动端：计算位置
              const tooltipEl = icon.querySelector('.rg-info-tips');
              if (tooltipEl && window.innerWidth <= 768) {
                self._positionMobileTooltip(icon, tooltipEl);
              }
              
              // 移动端禁止页面滚动
              document.body.style.overflow = 'hidden';
            } else {
              // 再次点击同一图标，关闭tooltip
              document.body.style.overflow = '';
            }
            return;
          }
          
          // 2. 点击提示框内容，阻止冒泡（不关闭）
          if (tooltip) {
            e.stopPropagation();
            return;
          }
          
          // 3. 点击container内其他区域，关闭所有 tooltip
          self._closeAllTooltips(container);
          document.body.style.overflow = '';
        };
        
        // 绑定点击事件到 container 级别（事件委托）
        container.addEventListener('click', self.tooltipEventHandlers.click);
        
        // 全局点击事件（用于点击container外部关闭） - 只绑定一次
        if (!self.globalClickHandlerBound) {
          self.globalClickHandler = function(e) {
            // 检查是否点击了 tooltip 相关元素
            const clickedIcon = e.target.closest('.rg-info-tips-icon');
            const clickedTooltip = e.target.closest('.rg-info-tips');
            
            // 如果点击的不是 tooltip 相关元素，关闭所有激活的 tooltip
            if (!clickedIcon && !clickedTooltip) {
              const hasActive = container.querySelector('.rg-info-tips-icon.active');
              if (hasActive) {
                self._closeAllTooltips(container);
                document.body.style.overflow = '';
              }
            }
          };
          document.addEventListener('click', self.globalClickHandler);
          self.globalClickHandlerBound = true;
        }
      },
      
      /**
       * 初始化桌面端 Tooltip（键盘支持）
       */
      _initDesktopTooltips: function(tooltipIcons) {
        const self = this;
        
        tooltipIcons.forEach(function(icon) {
          // 可访问性属性
          icon.setAttribute('tabindex', '0');
          icon.setAttribute('role', 'button');
          
          // 键盘事件
          icon.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const isActive = icon.classList.contains('active');
              if (isActive) {
                self._closeSingleTooltip(icon);
              } else {
                icon.classList.add('active');
              }
            } else if (e.key === 'Escape') {
              self._closeSingleTooltip(icon);
            }
          });
          
          // 失去焦点时关闭
          icon.addEventListener('blur', function() {
            if (icon.classList.contains('active')) {
              self._closeSingleTooltip(icon);
            }
          });
        });
      },
      
      /**
       * 初始化窗口 resize 处理
       */
      _initResizeHandler: function(container) {
        const self = this;
        let resizeTimer;
        
        self.tooltipEventHandlers.resize = function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            self._closeAllTooltips(container);
          }, 250);
        };
        
        window.addEventListener('resize', self.tooltipEventHandlers.resize);
      },
      
      /**
       * 初始化 Tooltip 功能：信息提示浮层
       */
      initTooltips: function() {
        const self = this;
        
        // 防止重复初始化
        if (self.tooltipInitialized) {
          return;
        }
        
        const container = document.querySelector('.account-discount');
        if (!container) {
          return;
        }
        
        const tooltipIcons = container.querySelectorAll('.rg-info-tips-icon');
        if (tooltipIcons.length === 0) {
          return;
        }
        
        const isTouchDevice = self._isTouchDevice();
        
        // 根据设备类型初始化
        if (isTouchDevice) {
          self._initMobileTooltips(container, tooltipIcons);
        } else {
          self._initDesktopTooltips(tooltipIcons);
        }
        
        // 窗口大小改变时关闭所有 tooltip
        self._initResizeHandler(container);
        
        self.tooltipInitialized = true;
      },
      
      /**
       * 清理 Tooltip 事件监听器（如需要）
       */
      _cleanupTooltips: function() {
        const self = this;
        const container = document.querySelector('.account-discount');
        
        if (container && self.tooltipEventHandlers.click) {
          container.removeEventListener('click', self.tooltipEventHandlers.click);
        }
        
        if (self.tooltipEventHandlers.resize) {
          window.removeEventListener('resize', self.tooltipEventHandlers.resize);
        }
        
        // 移除全局点击事件
        if (self.globalClickHandler) {
          document.removeEventListener('click', self.globalClickHandler);
          self.globalClickHandlerBound = false;
          self.globalClickHandler = null;
        }
        
        self.tooltipInitialized = false;
      },
      async getGiftCards() {
        this.isLoading = true;
        const url = this.apiUrl+`/api/lottery/shopify-gift-cards${this.lang ? '?lang='+this.lang :'' }`;

        const _data = { 
          email:this.email, 
          storeName: this.storeName,
          page:this.page || 1, 
          pageSize:this.pageSize||10,
          filter:"active"
        };
        try {
            const res =await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Token": this.accessToken
                },
                body: JSON.stringify(_data),
            });
            const data =await res.json();
            // 判断返回的code值
            if (data.code == 200) { 
              this.giftCardNumber = data.data.total || 0;
            } 
        } catch(error) {
        
        }
      },
      init() {
        this.getUser();
        this.getInfo();
        this.getPointsTask();
        // this.getUserCoupon();
        // this.getUserPointsDetails();
        
        // 初始化 Tooltip
        const self = this;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
            self.initTooltips();
          });
        } else {
          setTimeout(function() {
            self.initTooltips();
          }, 100);
        }
      },
    };
  }

  function accountRedeemPage() {
    return {
      page: 1,
      total: 0,
      pageSize: 8,
      productPage: 1,
      productTotal: 0,
      productPageSize: 8,
      couponTotalPages: 0,
      productTotalPages: 0,
      exchangeChannelId: 2,
      isLoading: false,
      productIsLoading: false,
      couponList: [],
      usePlatformId: window.renogyConfig.storeId,
      noCuponData: false,
      productNoData: false,
      productCouponList: [],
      shopCurrencySymbol: "$",
      activeTab: "coupon",
      activeId: "",
      isRedeem:true,
      apiUrl:"",
      recordId:null,
      customerEmail:"",
      toastTipsIcon:`<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <rect x="6" y="8" width="16" height="16" rx="8" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
        <path d="M14 12V15.6C14 15.8209 14.1791 16 14.4 16H18" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
        <line x1="12" y1="5" x2="16" y2="5" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
        <path d="M15 7.29961L13 7.29961L13 4.59961L15 4.59961L15 7.29961Z" fill="#00C0FF"/>
        <line x1="20" y1="9.58579" x2="20.99" y2="8.59584" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
        </svg>`,
      exchangeCoupon:async function (id,appliesToEntity) {
        const couponLimitInfo = {
            email:this.customerEmail,
            type:appliesToEntity == 'categories' ? 'coupon_code' : 'product_coupon',
            limitCount:Number(window.customerSetting.product_coupon.limitCount),
            limitDay:Number(window.customerSetting.product_coupon.limitDay)
        }
        
        await this.checkCouponLimit(couponLimitInfo);
        if(!this.isRedeem){ 
            this.renderToast(this.toastTipsIcon,window.customerSetting.coupon.not_enough_times_text);
            return ;
        }
        // 兑换优惠券
        Swal.fire({
          text: "Are you sure?",
          iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#00805E"/>
                    <path d="M18 30L26.3333 38.5L43 21.5" stroke="#00805E" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                  `,
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          customClass: {
            container: "kaios_swal",
          },
        }).then((result) => {
          if (result.value) {
            
            request("/mem-service/api/v1/bigcommerce/exchange_coupon", {
              method: "POST",
              body: JSON.stringify({
                couponTemplateId: id,
              }),
            })
              .then((resp) => {
                if (resp.code === "000000") {
                  Swal.fire({
                    text: "Success!",
                    iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#00805E"/>
                    <path d="M18 30L26.3333 38.5L43 21.5" stroke="#00805E" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                  `,
                    customClass: {
                      container: "my-swal my-swal-success kaios_swal",
                    },
                  });

                  window.location.href = "/pages/wallet";
                } else {
                  this.deleteRecordIdData();
                  Swal.fire({
                    text: "Error",
                    iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#A4A4A4"/>
                    <path d="M21.9961 21.998L37.9987 38.0007" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                    <path d="M21.9961 38.0007L37.9987 21.998" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                    `,
                    customClass: {
                      container: "my-swal my-swal-error kaios_swal",
                    },
                  });
                }
              })
              .catch(() => {
                this.deleteRecordIdData();
                Swal.fire({
                  text: "Error",
                  iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#A4A4A4"/>
                  <path d="M21.9961 21.998L37.9987 38.0007" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M21.9961 38.0007L37.9987 21.998" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                  </svg>
                  `,
                  customClass: {
                    container: "my-swal my-swal-error kaios_swal",
                  },
                });
              });
          }else{
            this.deleteRecordIdData();
          }
        });
      },
      deleteRecordIdData(){
        const url = this.apiUrl+`/api/coupon/delete-record`;
        try {
            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Token": this.accessToken
                },
                body: JSON.stringify({recordId: this.recordId,email:this.customerEmail}),
            })
        } catch(error) {
            throw error;
        }
      },
      getSite(){
        const currentDomain = window.location.hostname;
        switch (currentDomain) {
        case "uk.renogy.com":
            return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
        case "www.renogy.com":
            return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
        case "ca.renogy.com":
            return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
          case "eu.renogy.com":
            return {site:"EU",apiUrl:`https://shopify-api.renogy.com`};
        case "au.renogy.com":
            return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
        case "de.renogy.com":
            return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
        case "jp.renogy.com":
            return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
        case "fr.renogy.com":
            return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
        case "nl.renogy.com":
            return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
        case "it.renogy.com":
            return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
        case "es.renogy.com":
            return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
        default:
            return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
        }
      },
      // toast
      renderToast(toastIcon,msg,duration = 6000){
          Swal.fire(
              {
                  toast: true,
                  position: 'center',
                  title: msg,
                  customClass: {
                  popup: 'custom-error-toast',
                  container: 'custom-error-toast-container',
                  },
                  iconHtml:toastIcon,
                  showConfirmButton: false,
                  timer: duration,
                  didClose: () => {
                      this.playBtn.disabled = false;
                  }
              }
          )
      },
      async checkCouponLimit(couponInfo){
        const url = this.apiUrl+`/api/coupon/check-limit`;
        try {
            const res =await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Token": this.accessToken
                },
                body: JSON.stringify(couponInfo),
            });
            const data =await  res.json();
            // 判断返回的code值
            if (data.code !== 200) { 
                this.isRedeem = false;
            } 
            this.recordId = data.data?.recordId || '';
        } catch(error) {
            this.isRedeem = false;
        }
      },
      openCoupon: function (id) {
        if (this.activeId === id) {
          this.activeId = "";
        } else {
          this.activeId = id;
        }
      },
      switchTab: function (tab) {
        if (this.activeTab === tab) return;
        this.hidePagination();
        this.activeTab = tab;
        if (tab === "product") {
          this.getProductCouponTemplate();
        } else {
          this.getCouponTemplate();
        }
      },
      hidePagination: function () {
        document.dispatchEvent(
          new CustomEvent("hide:pagination", {
            bubbles: true,
          })
        );
      },
      initPagination: function (totalPages, page) {
        document.dispatchEvent(
          new CustomEvent("init:pagination", {
            detail: {
              totalPages: totalPages,
              page: page,
            },
            bubbles: true,
          })
        );
      },
      getProductCouponContainer: function () {
        return document.querySelector(".account-redeem-product-coupon");
      },
      getProductCouponLabels: function () {
        const i18nEl = document.querySelector(".account-redeem-i18n");
        if (!i18nEl) {
          return {
            free: "Free",
            code: "Code",
            redeemCopy: "Copy and Use",
          };
        }
        return {
          free: i18nEl.dataset.free || "Free",
          code: i18nEl.dataset.code || "Code",
          redeemCopy: i18nEl.dataset.redeemCopy || "Copy and Use",
        };
      },
      productCouponExpiresText: function (coupon) {
        const startDate = new Date(coupon.createDate);
        const couponExpiresNew = Number(coupon.couponExpires);
        if (isNaN(startDate.getTime())) {
          return "";
        }
        const resultDate = new Date(
          startDate.getTime() + couponExpiresNew * 24 * 60 * 60 * 1000
        );
        const month =
          resultDate.getMonth() + 1 > 9
            ? `${resultDate.getMonth() + 1}`
            : `0${resultDate.getMonth() + 1}`;
        const day =
          resultDate.getDate() > 9
            ? `${resultDate.getDate()}`
            : `0${resultDate.getDate()}`;
        return `${resultDate.getFullYear()}-${month}-${day}`;
      },
      getProductCouponTemplate: function () {
        this.hidePagination();
        this.productIsLoading = true;
        request(
          "/mem-service/api/v1/bigcommerce/page_coupon_template?exchangeChannelList=0&exchangeChannelList=2" +
            "&appliesToEntity=products" +
            "&isNeedCouponTemplateProduct=1" +
            "&usePlatformId=" +
            this.usePlatformId +
            "&pageSize=" +
            this.productPageSize +
            "&pageNum=" +
            this.productPage,
          {}
        ).then((resp) => {
          this.productIsLoading = false;
          if (resp.code === "000000") {
            this.productCouponList = (resp.data.contentList || [])
              .filter(
                (item) => item.couponTemplateProductDetailContentList?.length
              )
              .map((item) => ({
                ...item,
                product: item.couponTemplateProductDetailContentList[0],
              }));
            this.productTotal = resp.data.total || 0;
            this.productNoData = !this.productTotal;
            this.productTotalPages = Math.ceil(
              this.productTotal / this.productPageSize
            );
            if (this.activeTab === "product") {
              this.initPagination(this.productTotalPages, this.productPage);
            }
          }
        });
      },
      async checkProductCouponLimit(couponLimitInfo) {
        this.isRedeem = true;
        const url = this.apiUrl + `/api/coupon/check-limit`;
        try {
          const res = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Token": getAccessToken(),
            },
            body: JSON.stringify(couponLimitInfo),
          });
          const data = await res.json();
          if (data.code !== 200) {
            this.isRedeem = false;
          }
          this.recordId = data.data?.recordId || "";
        } catch (error) {
          this.isRedeem = false;
        }
      },
      redeemAccountProductCoupon: async function (couponId) {
        const couponInfo = this.productCouponList.find(
          (item) => item.couponTemplateId == couponId
        );
        if (!couponInfo || couponInfo.stock <= 0) {
          return;
        }

        const container = this.getProductCouponContainer();
        const couponLimitInfo = {
          email: this.customerEmail,
          type: "product_coupon",
          limitCount: Number(window.customerSetting.product_coupon.limitCount),
          limitDay: Number(window.customerSetting.product_coupon.limitDay),
        };

        await this.checkProductCouponLimit(couponLimitInfo);
        if (!this.isRedeem) {
          this.renderToast(
            this.toastTipsIcon,
            window.customerSetting.product_coupon.not_enough_times_text
          );
          return;
        }

        const membershipCouponDialogFirst = container.querySelector(
          ".membership-coupon-dialog-content-first"
        );
        const membershipCouponDialogSuccess = container.querySelector(
          ".membership-coupon-dialog-content-success"
        );
        const raysNumber = membershipCouponDialogFirst.querySelector(".rays-number");
        raysNumber.innerHTML = couponInfo.redeemBonusPoint;
        const closeBtnHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/>
          <rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/>
          <rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/>
        </svg>`;
        const firstDialogClone = membershipCouponDialogFirst.cloneNode(true);
        firstDialogClone.style.display = "block";
        const self = this;

        Swal.fire({
          showCloseButton: true,
          showCancelButton: true,
          showConfirmButton: true,
          html: firstDialogClone,
          closeButtonHtml: closeBtnHtml,
          confirmButtonText: "Redeem",
          cancelButtonText: "Cancel",
          customClass: {
            container: "membership-coupon-popup-container",
            popup: "membership-coupon-popup",
          },
        }).then((result) => {
          if (!result.isConfirmed) {
            self.deleteRecordIdData();
            return;
          }

          Swal.fire({
            html: `<div class=" is-loading"></div>`,
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
              container: "membership-coupon-popup-container",
              popup: "membership-coupon-popup",
            },
          });

          request("/mem-service/api/v1/bigcommerce/exchange_coupon", {
            method: "POST",
            body: JSON.stringify({
              couponTemplateId: couponInfo.couponTemplateId,
            }),
          })
            .then((resp) => {
              if (resp.code === "000000") {
                couponInfo.couponCode = resp.data.couponCode;
                self.confirmAccountProductCoupon(
                  membershipCouponDialogSuccess.cloneNode(true),
                  couponInfo,
                  closeBtnHtml
                );
                self.getProductCouponTemplate();
              } else {
                self.deleteRecordIdData();
                Swal.fire({
                  toast: true,
                  position: "center",
                  title: resp.msg,
                  customClass: {
                    popup: "custom-error-toast",
                    container: "custom-error-toast-container",
                  },
                  showConfirmButton: false,
                  timer: 6000,
                });
              }
            })
            .catch(() => {
              self.deleteRecordIdData();
              Swal.close();
            });
        });
      },
      confirmAccountProductCoupon: function (
        membershipCouponDialogSuccess,
        couponInfo,
        closeBtnHtml
      ) {
        const labels = this.getProductCouponLabels();
        const shopCurrency = window.Shopify.currency.active || "USD";
        const shopLocale =
          window.Shopify.locale + "-" + window.Shopify.country || "en-GB";
        const formatter = new Intl.NumberFormat(shopLocale, {
          style: "currency",
          currency: shopCurrency,
        });
        const currency = formatter
          .formatToParts(0)
          .find((part) => part.type === "currency").value;
        const product = couponInfo.product || couponInfo.couponTemplateProductDetailContentList[0];
        const successDialogClone = membershipCouponDialogSuccess.cloneNode(true);

        successDialogClone.querySelector(".membership-coupon-item").innerHTML = `
          <div class="membership-coupon-top membership-coupon-product-card">
            ${
              product.productImageUrl
                ? `<div class="product-card-img"><img width="100%" src="${product.productImageUrl}" /></div>`
                : `<div class="product-card-img" style="background:#F2FCFF;"></div>`
            }
            <div class="product-card-content">
              <div class="product-card-content-title">${product.productName}</div>
              <div class="product-card-content-sku">${product.sku}</div>
              <div class="product-card-content-price">
                <span class="free">${labels.free}</span>
                <span class="underline-price">${currency}${product.price}</span>
              </div>
            </div>
          </div>
          <div class="membership-coupon-item-line-box">
            <div class="membership-coupon-item-line"></div>
          </div>
          <div class="membership-coupon-b">
            <div class="membership-coupon-b-top">
              <div class="membership-coupon-b-top-content">
                <div class="membership-coupon-b-top-content-title">${labels.code}:
                  <span class="membership-coupon-b-top-content-des">${couponInfo.couponCode}</span>
                </div>
              </div>
              <product-form>
                <form class="js-product-form" id="form-id-${product.productId}" method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="id" value="${product.productId}" disabled>
                  <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-coupon-id="${couponInfo.couponTemplateId}">
                    ${labels.redeemCopy}
                  </button>
                </form>
              </product-form>
            </div>
          </div>
        `;

        let membershipCouponRuleHtml = "";
        if (couponInfo.couponRuleList?.length) {
          couponInfo.couponRuleList.forEach((rule) => {
            membershipCouponRuleHtml += `<div class="membership-coupon-b-bottom-rule">${rule}</div>`;
          });
        }
        successDialogClone.querySelector(
          ".membership-coupon-b-bottom-rules-box"
        ).innerHTML = membershipCouponRuleHtml;

        Swal.fire({
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          html: successDialogClone,
          closeButtonHtml: closeBtnHtml,
          customClass: {
            container: "membership-coupon-popup-container",
            popup: "membership-coupon-popup",
          },
        });
      },
      getCouponTemplate: function () {
        // 分页查询普通优惠券模板（categories）
        this.hidePagination();
        this.isLoading = true;
        request(
          "/mem-service/api/v1/bigcommerce/page_coupon_template?exchangeChannelList=0&exchangeChannelList=2" +
            "&appliesToEntity=categories" +
            "&usePlatformId=" +
            this.usePlatformId +
            "&pageSize=" +
            this.pageSize +
            "&pageNum=" +
            this.page,
          {}
        ).then((resp) => {
          this.isLoading = false;
          if (resp.code === "000000") {
            this.couponList = resp.data.contentList.map((item) => {
              const couponExpires = item.couponExpires.includes("9999-12-31")
                ? `${
                    item.couponExpires
                      .replace("9999", new Date().getFullYear())
                      .split(" ")[0]
                  }`
                : `${(item.couponExpires || "").split(" ")[0]}`;
              item.couponExpires = couponExpires;
              if (item.couponTypeId === 2) {
                item.couponAmount = item.couponAmount;
                item.currency = "%";
              } else {
                item.currency = "€";
              }
              return item;
            });

            const total = resp.data.total;
            const totalPages = Math.ceil(total / this.pageSize);
            this.couponTotalPages = totalPages;
            if (!total) {
              this.noCuponData = true;
            }
            if (this.activeTab === "coupon") {
              this.initPagination(totalPages, this.page);
            }
            if (totalPages > this.page) {
              this.page = this.page + 1;
            }
          }
        });
      },
      updateData() {
        const self = this;
        document.addEventListener("change:pagination:data", function (event) {
          if (self.activeTab === "product") {
            self.productPage = event.detail.page;
            self.getProductCouponTemplate();
            return;
          }
          self.page = event.detail.page;
          self.isLoading = true;
          self.couponList = [];
          self.getCouponTemplate();
        });
      },
      getUser: function () {
        request("/api/v1/account/security/get_security_info", {})
          .then((resp) => {
            if (resp.code === "000000") {
              console.log(resp.data);
              this.customerEmail = resp.data.email.email;
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },
      async init() {
        const link = new URL(window.location.href);
        let page = link.searchParams.get("page");
        if (page) {
          this.page = page;
        }
        const shopCurrency = window.Shopify.currency.active || "USD";
        const shopLocale =
          (window.Shopify.locale || "en") + "-" + (window.Shopify.country || "US");
        const formatter = new Intl.NumberFormat(shopLocale, {
          style: "currency",
          currency: shopCurrency,
        });
        this.shopCurrencySymbol = formatter
          .formatToParts(0)
          .find((part) => part.type === "currency").value;
        this.apiUrl = this.getSite().apiUrl;
        this.getUser();
        this.getCouponTemplate();
        this.getProductCouponTemplate();
        this.updateData();
      },
    };
  }

  function walletPage() {
    return {
      walletList: [],
      page: 1,
      total: 0,
      pageSize: 8,
      isLoading: false,
      noData: false,
      activeIndex: 1,
      usePlatformId: window.renogyConfig.storeId,
      changeTab: function (tab) {
        this.page = 1;
        this.activeIndex = tab;
        document.dispatchEvent(
          new CustomEvent("init:pagination", {
            detail: {
              totalPages: 0,
              page: 1,
            },
            bubbles: true,
          })
        );
        this.getWallet();
      },
      copyCouponCode(code,flag = false) {
        navigator.clipboard
          .writeText(code)
          .then(() => {
            if(flag){
              return;
            }
            Swal.fire({
              position: "top",
              html: document.querySelector("#code-copied-tip").innerHTML,
              showConfirmButton: false,
              customClass: "checked-true",
              timer: 2000,
            });
          })
          .catch((err) => {
            console.error("复制失败:", err);
          });
      },
      // async getWalletRays() {
      //   /**
      //    * status: 1 => Usable, 2 => Used, 3 => Expired
      //    */
      //   this.isLoading = true;
      //   this.apiUrl = `https://06b1c35b52a5.ngrok-free.app`
      //   const url = this.apiUrl+`/api/lottery/user-records${this.lang ? '?lang='+this.lang :'' }`;
      //   const _data = { 
      //     email:this.customerEmail || '1442123510@qq.com' , 
      //     storeName: this.storeName,
      //     page:this.page || 1, 
      //     prizeType:["product_coupon", "coupon_code"],
      //     pageSize:8
      //   };
      //   try {
      //       const res = await  fetch(url, {
      //           method: "POST",
      //           headers: {
      //               "Content-Type": "application/json",
      //               "X-Token": this.accessToken
      //           },
      //           body: JSON.stringify(_data),
      //       });
            
      //       const data = await res.json();
      //       this.isLoading = false;
      //       // 判断返回的code值
      //       if (data.code == 200) { 
      //         this.walletList = data.data.records || [];
      //         if(this.walletList.length < 1){
      //           this.getWallet();
      //         }
      //         this.total = data.data.total;
      //         this.totalPagesRays = data.data.totalPages;
      //         this.totalPages = data.data.totalPages;
      //         if (!this.total) {
      //           this.noCuponData = true;
      //         }
      //         document.dispatchEvent(
      //           new CustomEvent("init:pagination", {
      //             detail: {
      //               totalPages: this.totalPages,
      //               page: this.page,
      //             },
      //             bubbles: true,
      //           })
      //         );
      //         if (this.totalPages > this.page) {
      //           this.page = this.page + 1;
      //         }
      //       } 
      //   } catch(error) {
      //     this.isLoading = false;
      //     console.log("error", error)
      //   }
        
      // },
      getWallet() {
        /**
         * status: 1 => Usable, 2 => Used, 3 => Expired
         */
        this.isLoading = true;
        const url = `/mem-service/api/v1/bigcommerce/page_user_coupon?pageSize=${this.pageSize}&pageNum=${this.page}&couponStatus=${this.activeIndex}&usePlatformId=${this.usePlatformId}&isNeedCouponTemplateProduct=true`;
        request(url, {}).then((resp) => {
          this.isLoading = false;
          if (resp.code === "000000") {
            this.walletList = resp.data.contentList.map((item) => {
              const couponExpires = item.couponExpires.includes("9999-12-31")
                ? `${
                    item.couponExpires
                      .replace("9999", new Date().getFullYear())
                      .split(" ")[0]
                  }`
                : `${(item.couponExpires || "").split(" ")[0]}`;
              item.couponExpires = couponExpires;
              if (item.couponTypeId === 2) {
                item.currency = "%";
              } else {
                item.currency = "€";
              }
              return item;
            });
            const total = resp.data.total;

            const totalPages = Math.ceil(total / this.pageSize);

            if (!total) {
              this.noData = true;
            }

            document.dispatchEvent(
              new CustomEvent("init:pagination", {
                detail: {
                  totalPages: totalPages,
                  page: this.page,
                },
                bubbles: true,
              })
            );
            if (totalPages > this.page) {
              this.page = this.page + 1;
            }
          }
        });
      },
      updateData() {
        const self = this;
        document.addEventListener("change:pagination:data", function (event) {
          self.page = event.detail.page;
          self.isLoading = true;
          self.walletList = [];
          self.getWallet();
        });
      },
      init() {
        const link = new URL(window.location.href);
        let page = link.searchParams.get("page");
        if (page) {
          this.page = page;
        }
        this.getWallet();
        this.updateData();
      },
    };
  }

  function giftCardPage() {
    return {
      giftCardList: [],
      page: 1,
      total: 0,
      pageSize: 8,
      isLoading: false,
      noData: false,
      activeIndex: 1,
      usePlatformId: window.renogyConfig.storeId,
      apiUrl:"",
      isRedeem:false,
      showRules:false,
      apiUrl:"",
      storeName:"",
      language:{
        en:{
          usable:"Usable",
          used:"Used",
          expired:"Expired",
          disabled:"Disabled"
        },
        ja:{
          usable:"使用可能",
          used:"使用済み",
          expired:"期限切れ",
          disabled:"無効"
        },
        de:{
          usable:"Verfügbar",
          used:"Verwendet",
          expired:"Abgelaufen",
          disabled:"Deaktiviert"
        },
        fr:{
          usable:"Utilisable",
          used:"Utilisé",
          expired:"Expiré",
          disabled:"Désactivé"
        },
        it:{
          usable:"Utilizzabile",
          used:"Usato",
          expired:"Scaduto",
          disabled:"Disabilitato"
        },
        es:{
          usable:"Usable",
          used:"Usado",
          expired:"Caducado",
          disabled:"Desactivado"
        },
        nl:{
          usable:"Beschikbaar",
          used:"Gebruikt",
          expired:"Verlopen",
          disabled:"Uitgeschakeld"
        }
      },
      changeTab: function (tab) {
        this.page = 1;
        this.activeIndex = tab;
        document.dispatchEvent(
          new CustomEvent("init:pagination", {
            detail: {
              totalPages: 0,
              page: 1,
            },
            bubbles: true,
          })
        );
        this.getGiftCards();
      },
      copyCouponCode(code) {
        navigator.clipboard
          .writeText(code)
          .then(() => {
            Swal.fire({
              position: "top",
              html: document.querySelector("#code-copied-tip").innerHTML,
              showConfirmButton: false,
              customClass: "checked-true",
              timer: 2000,
            });
          })
          .catch((err) => {
            console.error("复制失败:", err);
          });
      },
      getUser: function () {
        request("/api/v1/account/security/get_security_info", {})
          .then((resp) => {
            if (resp.code === "000000") {
              this.customerEmail = resp.data.email.email;
              this.getGiftCards();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },
      async getGiftCards() {
        /**
         * status: 1 => Usable, 2 => Used, 3 => Expired
         */
        // this.apiUrl = `https://06b1c35b52a5.ngrok-free.app`;
        this.isLoading = true;
        this.giftCardList = [];
        const url = this.apiUrl+`/api/lottery/shopify-gift-cards${this.lang ? '?lang='+this.lang :'' }`;

        const _data = { 
          email:this.customerEmail, 
          storeName: this.storeName,
          page:this.page || 1, 
          pageSize:this.pageSize,
        };
        if(this.activeIndex == 1){ 
          _data.filter = "active";
        }else if(this.activeIndex == 2){ 
          _data.filter = "empty";
        }else if(this.activeIndex == 3){ 
          _data.filter = "expired";
        }else if(this.activeIndex == 4){
          _data.filter = "all";
        }
        try {
            const res =await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Token": this.accessToken
                },
                body: JSON.stringify(_data),
            });
            
            const data =await res.json();
            this.isLoading = false;
            // 判断返回的code值
            if (data.code == 200) { 
              let giftCards = data.data.giftCards || [];
              if (this.activeIndex == 4) {
                giftCards = giftCards.filter((item) => item.enabled === false);
              }
              giftCards.forEach(item=>{
                this.statusGiftCard(item)
              });
              this.giftCardList = giftCards;
              console.log("giftCardList",this.giftCardList)
              this.total = data.data.total;
              this.totalPages = data.data.totalPages;
              if (!this.total) {
                this.noCuponData = true;
              }
              document.dispatchEvent(
                new CustomEvent("init:pagination", {
                  detail: {
                    totalPages: this.totalPages,
                    page: this.page,
                  },
                  bubbles: true,
                })
              );
              if (this.totalPages > this.page) {
                this.page = this.page + 1;
              }
            } 
        } catch(error) {
          this.isLoading = false;
          console.log("error", error)
        }
      },

      statusGiftCard(giftCard){
        const self = this;
        let language = null;
        switch (self.storeName){
          case "JP":
            language = self.language.ja;
          case "DE":
            language = self.language.de;
          case "FR":
            language = self.language.fr;
          case "IT":
            language = self.language.it;
          case "ES":
            language = self.language.es;
          case "NL":
            language = self.language.nl;
          default:
            language = self.language.en;
        }
        if(this.activeIndex == 1){
          giftCard.status = 1;
          giftCard.statusText = language.usable;
        }else if(this.activeIndex == 2){
          giftCard.status = 2;
          giftCard.statusText = language.used;
        }else if(this.activeIndex == 3){
          giftCard.statusText = language.expired;
          giftCard.status = 3;
        }else if(this.activeIndex == 4){
          giftCard.statusText = language.disabled;
          giftCard.status = 3;
        }
      },
      getSite(){
        const currentDomain = window.location.hostname;
        switch (currentDomain) {
        case "uk.renogy.com":
            return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
        case "www.renogy.com":
            return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
        case "ca.renogy.com":
            return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
          case "eu.renogy.com":
            return {site:"EU",apiUrl:`https://shopify-api.renogy.com`};
        case "au.renogy.com":
            return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
        case "de.renogy.com":
            return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
        case "jp.renogy.com":
            return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
        case "fr.renogy.com":
            return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
        case "nl.renogy.com":
            return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
        case "it.renogy.com":
            return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
        case "es.renogy.com":
            return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
        default:
            return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
        }
      },
      updateData() {
        const self = this;
        document.addEventListener("change:pagination:data", function (event) {
          self.page = event.detail.page;
          self.isLoading = true;
          self.giftCardList = [];
          self.getGiftCards();
        });
      },
      init() {
        const link = new URL(window.location.href);
        let page = link.searchParams.get("page");
        if (page) {
          this.page = page;
        }
        this.storeName = this.getSite().site;
        this.apiUrl = this.getSite().apiUrl;
        this.getUser();
        this.getGiftCards();

        this.updateData();
      },
    };
  }
  function luckyDrawPage(){
    return {
      luckyDrawList: [],
      page: 1,
      total: 0,
      totalPages: 0,
      pageSize: 8,
      isLoading: false,
      noData: false,
      activeIndex: 1,
      usePlatformId: window.renogyConfig.storeId,
      customerEmail:"",
      apiUrl:"",
      storeName:"",
      isRedeem:false,
      copyToClipboard(coupon,copyButton){
        let coupon_ = JSON.parse(coupon);
        if(coupon_.prizeDetail.type == 'coupon_code'){
            if (copyButton.classList.contains('copied')) return;
                
                navigator.clipboard.writeText(coupon_.prizeDetail.value).then(() => {
                    // 显示打勾SVG图标
                    const originalText =  copyButton.textContent;
                     copyButton.innerHTML = `${originalText}
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    `;
                     copyButton.classList.add('copied');
                    
                    // 3秒后恢复原始状态
                    setTimeout(() => {
                        copyButton.innerHTML = originalText;
                        copyButton.classList.remove('copied');
                    }, 3000);
                }).catch(err => {
                    console.error('Failed to copy coupon code: ', err);
            });
        }
        if(coupon_.prizeDetail.type == 'product_coupon'){
            let maxTime= 0
            let copyButtonTimer = setInterval(() => {
                if(copyButton.classList.contains('is-success')){
                    Swal.close();
                    clearInterval(copyButtonTimer);
                }
                maxTime += 50;
            }, 10);
            if(maxTime >= 3000){
                Swal.close();
                clearInterval(copyButtonTimer);
            }
            // 防止重复点击
            if ( copyButton.classList.contains('copied')) return;
            
            navigator.clipboard.writeText(coupon_.prizeDetail.value).then(() => {
                // 显示打勾SVG图标
                const originalText =  copyButton.textContent;
                 copyButton.classList.add('copied');
                
                // 3秒后恢复原始状态
                setTimeout(() => {
                    copyButton.innerHTML = originalText;
                    copyButton.classList.remove('copied');
                }, 3000);
            }).catch(err => {
                console.error('Failed to copy coupon code: ', err);
            });
        }
      },
      getUser: function () {
        request("/api/v1/account/security/get_security_info", {})
          .then((resp) => {
            if (resp.code === "000000") {
              this.customerEmail = resp.data.email.email;
              this.getLuckyDraws();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },
      formatDateTimeForTimezone(isoString,isZontTime) {
            let date;
    
            // 判断输入时间类型
            if (isoString.includes('T') && isoString.endsWith('Z') && !isZontTime) {
                // 如果是UTC时间（Z结尾），直接使用
                date = new Date(isoString);
            } else {
                // 如果是不带时区的时间，假设为北京时间（UTC+8）
                // 将北京时间转换为UTC时间
                date = new Date(isoString);
                if (!isNaN(date.getTime())) {
                    // 减去8小时转换为UTC
                    date = new Date(date.getTime() - 8 * 60 * 60 * 1000);
                }
            }
            // 完整的国家配置
            const countryConfigs = {
                // 澳大利亚（英语）
                AU: {
                    locale: "en-AU",
                    timeZone: "Australia/Sydney",
                    hour12: true
                },
                // 加拿大（英语区）
                CA: {
                    locale: "en-CA",
                    timeZone: "America/Toronto",
                    hour12: true
                },
                // 德国
                DE: {
                    locale: "de-DE",
                    timeZone: "Europe/Berlin",
                    hour12: false
                },
                // 欧盟通用格式（德国标准）
                EU: {
                    locale: "en-GB",
                    timeZone: "Europe/Berlin",
                    hour12: false
                },
                // 日本
                JP: {
                    locale: "ja-JP",
                    timeZone: "Asia/Tokyo",
                    hour12: false
                },
                UK: {
                    locale: "en-GB",
                    timeZone: "Europe/London",
                    hour12: false  // 英国通常使用24小时制
                },
                // 美国
                US: {
                    locale: "en-US",
                    timeZone: "America/New_York",
                    hour12: true
                },
                // 意大利
                IT: {
                    locale: "it-IT",
                    timeZone: "Europe/Rome",
                    hour12: false
                },
                // 西班牙
                ES: {
                    locale: "es-ES",
                    timeZone: "Europe/Madrid",
                    hour12: false
                },
                // 法国
                FR: {
                    locale: "fr-FR",
                    timeZone: "Europe/Paris",
                    hour12: false
                },
                // 荷兰
                NL: {
                    locale: "nl-NL",
                    timeZone: "Europe/Amsterdam",
                    hour12: false
                },
                RenogyTest: {
                    locale: "en-GB",
                    timeZone: "Europe/London",
                    hour12: false  // 英国通常使用24小时制
                },
            }
            const config = countryConfigs[this.storeName];
            
            
            const formatter = new Intl.DateTimeFormat(config.locale, {
                timeZone: config.timeZone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: config.hour12
            });
            
            // 对于24小时制，我们需要手动格式化为YYYY-MM-DD HH:mm:ss
            if (!config.hour12) {
                const parts = formatter.formatToParts(date);
                const year = parts.find(part => part.type === 'year').value;
                const month = parts.find(part => part.type === 'month').value;
                const day = parts.find(part => part.type === 'day').value;
                const hour = parts.find(part => part.type === 'hour').value;
                const minute = parts.find(part => part.type === 'minute').value;
                const second = parts.find(part => part.type === 'second').value;
                
                return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            } else {
                // 12小时制处理
                return formatter.format(date);
            }
      },

      getSite(){
            const currentDomain = window.location.hostname;
            switch (currentDomain) {
            case "uk.renogy.com":
                return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
            case "www.renogy.com":
                return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
            case "ca.renogy.com":
                return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
             case "eu.renogy.com":
                return {site:"EU",apiUrl:`https://shopify-api.renogy.com`};
            case "au.renogy.com":
                return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
            case "de.renogy.com":
                return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
            case "jp.renogy.com":
                return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
            case "fr.renogy.com":
                return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
            case "nl.renogy.com":
                return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
            case "it.renogy.com":
                return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
            case "es.renogy.com":
                return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
            default:
                return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
            }
      },
      async getLuckyDraws() {
        /**
         * status: 1 => Usable, 2 => Used, 3 => Expired
         */
        this.isLoading = true;
        // this.apiUrl = `https://06b1c35b52a5.ngrok-free.app`
        const url = this.apiUrl+`/api/lottery/user-records${this.lang ? '?lang='+this.lang :'' }`;
        const _data = { 
          email:this.customerEmail, 
          storeName: this.storeName,
          page:this.page || 1, 
          pageSize:8
        };
        try {
            const res = await  fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Token": this.accessToken
                },
                body: JSON.stringify(_data),
            });
            
            const data = await res.json();
            this.isLoading = false;
            // 判断返回的code值
            if (data.code == 200) { 
              this.luckyDrawList = data.data.records || [];
              this.total = data.data.total;
              this.totalPages = data.data.totalPages;
              if (!this.total) {
                this.noCuponData = true;
              }
              document.dispatchEvent(
                new CustomEvent("init:pagination", {
                  detail: {
                    totalPages: this.totalPages,
                    page: this.page,
                  },
                  bubbles: true,
                })
              );
              if (this.totalPages > this.page) {
                this.page = this.page + 1;
              }
            } 
        } catch(error) {
          this.isLoading = false;
          console.log("error", error)
        }
        
      },
      updateData() {
        const self = this;
        document.addEventListener("change:pagination:data", function (event) {
          self.page = event.detail.page;
          self.isLoading = true;
          self.luckyDrawList = [];
          self.getLuckyDraws();
        });
      },
      async init() {
        const link = new URL(window.location.href);
        let page = link.searchParams.get("page");
        if (page) {
          this.page = page;
        }
        this.storeName = this.getSite().site;
        this.getLuckyDraws();
        this.apiUrl = this.getSite().apiUrl;
        // this.apiUrl = `https://06b1c35b52a5.ngrok-free.app`;

        this.getUser();
        // this.getLuckyDraws();
        this.updateData();
      },
    }
  }
  function getRecommendProducts() {
    return {
      bundleList: [],
      selectList: [],
      bundleFirst: {},
      mainProduct: {
        id: window.buyProduct.curProduct.id,
        price: window.buyProduct.curProduct.price,
        old_price: window.buyProduct.curProduct.old_price,
        option: window.buyProduct.curProduct.option || "",
        qty: 1,
      },
      mainProductNum: 1,
      showBundle: false,
      totalPriceObj: {
        price: 0,
        old_price: 0,
        showSalePrice: false,
      },
      loading: false,
      addItemsToCart(callback) {
        this.loading = true;
        let formData = new FormData();
        let sections = "cart-icon-bubble";
        let cartDrawer = document.querySelector(
          ".shopify-section.cc-cart-drawer"
        );
        if (cartDrawer) {
          sections += `,${cartDrawer
            .closest(".shopify-section")
            .id.replace("shopify-section-", "")}`;
        }
        formData.append("sections", sections);
        formData.append("sections_url", window.location.pathname);
        const data = [
          {
            id: window.buyProduct.curProduct.id,
            qty: this.mainProductNum,
          },
          ...this.bundleList
            .filter((item) => this.selectList.includes(item.id))
            .map((item) => {
              return {
                id: item.id,
                qty: item.qty,
              };
            }),
        ];
        data.forEach((item, index) => {
          formData.append("items[" + index + "][id]", item.id);
          formData.append("items[" + index + "][quantity]", item.qty);
        });
        fetch(window.theme.routes.cart + "/add", {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (!response.items) {
              if (response.message) {
                Swal.fire({
                  text: response.message,
                  iconHtml: `<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M29.999 59C13.7071 59 0.5 45.7908 0.5 29.499C0.5 13.2071 13.7071 0 29.999 0C46.2908 0 59.4979 13.2071 59.4979 29.499C59.4979 45.7908 46.2908 59 29.999 59ZM29.999 4.21625C16.0354 4.21625 4.71414 15.5375 4.71414 29.5011C4.71414 43.4646 16.0354 54.7859 29.999 54.7859C43.9625 54.7859 55.2838 43.4646 55.2838 29.5011C55.2838 15.5375 43.9625 4.21625 29.999 4.21625Z" fill="#A4A4A4"/>
                  <path d="M21.9961 21.998L37.9987 38.0007" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M21.9961 38.0007L37.9987 21.998" stroke="#A4A4A4" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
                  </svg>
                  `,
                  customClass: {
                    container: "my-swal my-swal-error",
                  },
                });
              }
              this.loading = false;
              return;
            }
            const cartIconBubble = document.getElementById("cart-icon-bubble");
            if (cartIconBubble) {
              cartIconBubble.innerHTML = response.sections["cart-icon-bubble"];
            }

            setTimeout(() => {
              const cartItems = document.querySelector("cart-items");
              if (cartItems) {
                if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }

              this.getCart();
              callback && callback();
            }, 700);
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.error("Error:", error);
          });
        try {
          sensors.track("AddBundleToCartClick", {
            addType: "Bundle",
            bundle_sku_id_list: this.bundleList
              .filter((item) => this.selectList.includes(item.id))
              .map((item) => {
                return {
                  id: item.id,
                };
              }),
            cart_id: "",
            total_bundle_now_price: this.calcTotalPrice(),
          });
        } catch (error) {
          console.error("add bundle error", error);
        }
      },
      getCart() {
        fetch(`${window.theme.routes.cart}.js`)
          .then((res) => {
            return res.json();
          })
          .then((response) => {
            const cartIcon = document.getElementById("cart-icon");
            if (cartIcon) {
              cartIcon.click();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      },
      getProducts() {
        const url = window.renogyConfig.recommendationsApi;
        request(
          url,
          {
            method: "POST",
            body: JSON.stringify({
              customerId: 0,
              customerGroupId: -1,
              productId: window.buyProduct.productId,
            }),
          },
          false,
          true
        ).then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            if (resp.data && resp.data.bundleProducts.length) {
              this.bundleList = resp.data.bundleProducts.map((item) => {
                let product = item;
                if (product.variants.length > 0) {
                  let variant = product.variants[0];
                  product.img = variant.image?.url;
                  product.url = item.url;
                  product.name = item.name;
                  product.salePrice = variant.compareAtPrice;
                  product.id = product.variants[0].id.replace(
                    "gid://shopify/ProductVariant/",
                    ""
                  );
                  product.option = variant.title;
                }
                if (product.salePrice > product.price) {
                  product.showSalePrice = true;
                }
                return {
                  ...product,
                  qty: 1,
                };
              });

              this.showBundle = true;
              this.bundleFirst = this.bundleList[0];
              this.selectList = [this.bundleFirst.id];
              this.calcTotalPrice();
            }
          }
        });
      },
      // 选中bundle产品
      selectBundle(bundleId) {
        if (this.selectList.includes(bundleId)) {
          this.selectList = this.selectList.filter((item) => item != bundleId);
        } else {
          this.selectList.push(bundleId);
        }
        this.calcTotalPrice();
        trackBundleItemChoose(bundleId);
      },
      // 计算总价格
      calcTotalPrice() {
        const temp = this.bundleList
          .filter((item) => this.selectList.includes(item.id))
          .map((item) => {
            return {
              price: item.price * item.qty * 100,
              old_price: item.salePrice * item.qty * 100,
            };
          });
        const totalBundlePrice = temp.reduce((acc, cur) => {
          return acc + cur.price;
        }, 0);
        const totalBundleOldPrice = temp.reduce((acc, cur) => {
          return acc + cur.old_price;
        }, 0);
        this.totalPriceObj.price =
          ((totalBundlePrice +
            window.buyProduct.curProduct.price * this.mainProductNum * 100) /
          100).toFixed(2);
        this.totalPriceObj.old_price =
          (totalBundleOldPrice +
            window.buyProduct.curProduct.old_price *
              this.mainProductNum *
              100) /
          100;
        if (this.bundleFirst.old_price > this.bundleFirst.price) {
          this.totalPriceObj.showSalePrice = true;
        }
      },
      // 修改产品数量
      changeBundleNum(el, type) {
        console.log(el.target.value, type);
        if (type === "main_product") {
          this.mainProductNum = el.target.value;
        } else {
          this.bundleList.find((item) => item.id === type).qty =
            el.target.value;
        }
        this.calcTotalPrice();
      },
      init() {
        this.getProducts();
        const self = this;

        document.addEventListener("product:info", function (event) {
          console.log(event.detail);
          window.buyProduct.curProduct.id = event.detail.id;
          window.buyProduct.curProduct.price = event.detail.price / 100;
          window.buyProduct.curProduct.old_price =
            event.detail.compare_at_price / 100;
          window.buyProduct.curProduct.option = event.detail.option;
          self.mainProduct.id = event.detail.id;
          self.mainProduct.price = event.detail.price / 100;
          self.mainProduct.old_price = event.detail.compare_at_price / 100;
          self.mainProduct.option = event.detail.option;
          self.calcTotalPrice();
          try {
            sensors.track("SkuOption", {
              commodity_id: event.detail.id,
              commodity_name: event.detail.option,
              commodity_sku: "",
            });
          } catch (error) {
            console.log("track sku option error:", error);
          }
        });

        window.addCat = () => {
          this.addItemsToCart([
            {
              id: 43748762386486,
              quantity: 1,
            },
          ]);
        };
      },
    };
  }

  function orderPage() {
    return {
      fulfillmentList: {},
      fulfillments() {
        const orderId = window.orderId;
        const orderItem = {};
        fetch(`/apps/renogy/orders/${orderId}/fulfillments`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((resp) => {
            if (resp.data && resp.data.length > 0) {
              resp.data.forEach((item) => {
                item.lineItems.forEach((lineItem) => {
                  if (orderItem[lineItem.id]) {
                    const temp = item.trackingInfo.map((item) => item.number);
                    orderItem[lineItem.id] = [
                      ...orderItem[lineItem.id],
                      ...temp,
                    ];
                  } else {
                    orderItem[lineItem.id] = item.trackingInfo.map(
                      (item) => item.number
                    );
                  }
                });
              });

              this.fulfillmentList = orderItem;
            }
          })
          .catch((err) => {
            console.log("Request Failed", err);
          });
      },
      isFulfilled(id) {
        return this.fulfillmentList[id] && this.fulfillmentList[id].length > 0
          ? "active"
          : "";
      },
      init() {
        this.fulfillments();
      },
    };
  }

  function wishlistPage() {
    return {
      products: [],
      page: 1,
      pageSize: 12,
      showNoData: false,
      isLoading: true,
      updateData() {
        const self = this;
        document.addEventListener("change:pagination:data", function (event) {
          self.page = event.detail.page;
          self.isLoading = true;
          self.walletList = [];
          self.getData();
        });
      },
      init() {
        const link = new URL(window.location.href);
        let page = link.searchParams.get("page");
        if (page) {
          this.page = page;
        }
        this.getData();
        this.updateData();
      },
      handleRemoveWish(product) {
        Swal.fire({
          title: "Are you sure delete this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            fetch(`/apps/renogy/wish/products/${product.id}`, {
              method: "delete",
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((res) => res.json())
              .then((res) => {
                if (res.status == 200) {
                  window.location.reload();
                }
              })
              .catch((err) => {
                this.isLoading = false;
                console.log("Request Failed", err);
              });
          }
        });
      },
      getData() {
        this.isLoading = true;
        fetch(
          `/apps/renogy/wish/products?page=${this.page}&pageSize=${this.pageSize}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((res) => {
            this.isLoading = false;
            if (res.status == 200) {
              this.products = res.data;

              const total = res.meta.total;
              const totalPages = Math.ceil(total / this.pageSize);

              if (total == 0) {
                this.showNoData = true;
              }

              document.dispatchEvent(
                new CustomEvent("init:pagination", {
                  detail: {
                    totalPages: totalPages,
                    page: this.page,
                  },
                  bubbles: true,
                })
              );
              if (totalPages > this.page) {
                this.page = this.page + 1;
              }
            }
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Request Failed", err);
          });
      },
    };
  }

  Alpine.data("wishlistPage", wishlistPage);
  Alpine.data("orderPage", orderPage);
  Alpine.data("getRecommendProducts", getRecommendProducts);
  Alpine.data("walletPage", walletPage);
  Alpine.data("giftCardPage", giftCardPage);
  Alpine.data("luckyDrawPage", luckyDrawPage);
  Alpine.data("accountHomePage", accountHomePage);
  Alpine.data("accountRedeemPage", accountRedeemPage);
  
  Alpine.data("pagination", pagination);
})();
